import { Component, forwardRef, Input, OnInit, Optional, Self } from "@angular/core";
import { ControlValueAccessor, NgControl } from "@angular/forms";
import { Validators } from "@angular/forms";

@Component({
	selector: "app-input",
	templateUrl: "input-text.component.html",
	// ← Remove the NG_VALUE_ACCESSOR provider, NgControl handles it
})
export class InputComponent implements ControlValueAccessor, OnInit {
	@Input() label = "";
	@Input() placeholder = "";
	@Input() type: "text" | "number" | "textarea" | "password" | "email" = "text";
	@Input() disabled = false;
	@Input() required = false;
	@Input() readonly = false;
	@Input() max?: number | string;
	@Input() min?: number | string;
	@Input() maxlength?: number;
	@Input() error: string | null = null;
	@Input() hint: string | null = null;
	@Input() rows = "5";
	@Input() cols = "30";

	value: any;
	private onChange: (value: any) => void = () => {};
	private onTouched: () => void = () => {};

	constructor(@Optional() @Self() public ngControl: NgControl) {
		if (this.ngControl) {
			this.ngControl.valueAccessor = this;
		}
	}

	ngOnInit(): void {}

	get hasError(): boolean {
		const ctrl = this.ngControl?.control;
		return !!(ctrl && ctrl.invalid && ctrl.touched);
	}

	get errorMessage(): string {
		const ctrl = this.ngControl?.control;
		if (!ctrl || !ctrl.errors) return "";
		if (ctrl.errors["required"]) return "Ce champ est obligatoire.";
		if (ctrl.errors["min"]) return `La valeur minimale est ${ctrl.errors["min"].min}.`;
		if (ctrl.errors["max"]) return `La valeur maximale est ${ctrl.errors["max"].max}.`;
		if (ctrl.errors["minlength"]) return `Minimum ${ctrl.errors["minlength"].requiredLength} caractères.`;
		if (ctrl.errors["maxlength"]) return `Maximum ${ctrl.errors["maxlength"].requiredLength} caractères.`;
		if (ctrl.errors["email"]) return "Adresse e-mail invalide.";
		return "Ce champ est invalide.";
	}

	get inputType(): string {
		return this.type === "number" ? "text" : this.type;
	}

	get inputMode(): string | null {
		return this.type === "number" ? "decimal" : null;
	}

	writeValue(value: any): void {
		this.value = value ?? "";
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	handleInput(event: Event): void {
		const target = event.target as HTMLInputElement;
		const raw = target.value;

		if (this.type === "number") {
			if (raw === "" || raw === "-" || raw.endsWith(".") || raw.endsWith(",")) {
				this.value = raw;
				this.onChange(null);
				return;
			}
			const normalized = raw.replace(",", ".");
			const parsed = parseFloat(normalized);
			this.value = raw;
			this.onChange(isNaN(parsed) ? null : parsed);
		} else {
			this.value = raw;
			this.onChange(raw);
		}
	}

	handleBlur(): void {
		if (this.type === "number") {
			const normalized = String(this.value ?? "").replace(",", ".");
			const parsed = parseFloat(normalized);
			this.value = isNaN(parsed) ? "" : parsed;
			this.onChange(isNaN(parsed) ? null : parsed);
		}
		this.onTouched();
	}
    get isRequired(): boolean {
    if (this.required) return true;
    const ctrl = this.ngControl?.control;
    if (!ctrl) return false;
    return ctrl.hasValidator(Validators.required);
}
}